import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import api from '../../services/api';
import toast from 'react-hot-toast';
import { Book, Plus, Search, Trash2 } from 'lucide-react';

export default function PhonebookPage() {
  const qc = useQueryClient();
  const [search, setSearch] = useState('');
  const { data, isLoading } = useQuery(['phonebook', search], () => api.get('/phonebook?search=' + search + '&limit=100').then(r => r.data), { keepPreviousData: true });
  const delMut = useMutation((id) => api.delete('/phonebook/' + id), { onSuccess: () => { qc.invalidateQueries('phonebook'); toast.success('Contacto eliminado'); } });
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div><h1 className="text-2xl font-bold text-white">Agenda</h1>
          <p className="text-gray-400 text-sm">{data?.total || 0} contactos</p></div>
      </div>
      <div className="card">
        <div className="relative mb-4 max-w-xs">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted" />
          <input aria-label="Buscar contacto" value={search} onChange={e => setSearch(e.target.value)} className="input pl-9" placeholder="Buscar..." />
        </div>
        <table className="w-full">
          <thead><tr>{['Nombre','Empresa','Telefono','Movil','Email'].map(h => <th key={h} className="table-th">{h}</th>)}</tr></thead>
          <tbody>
            {(data?.data || []).map(c => (
              <tr key={c.id} className="table-row">
                <td className="table-td font-medium text-gray-200">{c.first_name} {c.last_name}</td>
                <td className="table-td text-gray-400">{c.company || '-'}</td>
                <td className="table-td font-mono text-blue-400">{c.phone}</td>
                <td className="table-td font-mono text-gray-400">{c.mobile || '-'}</td>
                <td className="table-td text-gray-400 text-xs">{c.email || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
